import React, { useState } from "react";
import {
  alpha,
  Box,
  Card,
  CardActions,
  CardContent,
  Chip,
  CircularProgress,
  Container,
  Divider,
  IconButton,
  Switch,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { blue, grey } from "@mui/material/colors";
import styles from "./gridContainerStyles.js";
import { Edit, RecordCircle } from "iconsax-react";
import EditCategoryDialog from "../EditCategoryDialog/index.js";
import DeleteCategoryDialog from "../DeleteCategoryDialog/index.js";
import { notification } from "../../../utils/Notifications.js";
import { updateCategoryStatus } from "../../../api/categoriesApi.js";
import { usePermissions } from "../../../hooks/permissions/usePermissions.js";

const GridContainer = ({ search, categories, isLoading, setIsLoading, fetchCategories }) => {
  const { hasAllPermissions } = usePermissions();

  const [openDialog, setOpenDialog] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loadingCategoryId, setLoadingCategoryId] = useState(null);

  const handleDialogOpen = (dialogName) => {
    setOpenDialog(dialogName);
  };

  const handleDialogClose = () => {
    setOpenDialog(null);
  };

  const handleUpdateCategoryStatusClick = (category) => {
    if (isLoading) { return; }
    setIsLoading(true);
    setLoadingCategoryId(category.id_membership_type);

    updateCategoryStatus(category?.id_membership_type, !category?.is_active)
      .then((response) => {
        if (response.data.status_Code === 200) {
          notification({ 
            text: category?.is_active ? "Categoría desactivada" : "Categoría activada", 
            type: "success",
          });
          setLoadingCategoryId(null);
          fetchCategories();
        } else {
          notification({
            text: "Error al desactivar la categoría",
            type: "error",
          });
          setLoadingCategoryId(null);
          setIsLoading(false);
        }
      })
      .catch(() => {
        setLoadingCategoryId(null);
        setIsLoading(false);
        notification({text: 'Error de conexión, revisa tu conexión a internet', type: 'error'});
      });
  };

  const filteredCategories = categories.filter(category => 
    category.membership_name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Container
      style={{
        paddingTop: 24,
        paddingBottom: 24,
        backgroundColor: "#FFFFFF",
        borderRadius: "1rem",
      }}
    >
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        style={{ padding: "0px 0px" }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        {filteredCategories.map((category, index) => (
          <Grid xs={12} sm={6} md={6} lg={4} key={index}>
            <Card
              elevation={0}
              sx={{
                minWidth: 275,
                borderRadius: 4,
                border: `1px solid ${grey[200]}`,
                backgroundColor: grey[50],
              }}
            >
              <CardContent >
                <Box sx={styles.chipsContainer}>
                  
                  <Chip
                    icon={
                      <RecordCircle size="12" variant="Bold" style={styles.statusChip} />
                    }
                    sx={ category?.is_active ? styles.statusActiveChip : styles.statusInactiveChip }
                    label={ category?.is_active ? 'Activa' : 'Inactiva' }
                    size="small"
                  />

                  {/* {
                    category?.id_membership_type !== 1 && (
                      isLoading ? (
                        <CircularProgress size={24} style={styles.circularProgress} />
                      ) : (
                        <Switch
                          checked={category.is_active}
                          onChange={() => {
                            handleUpdateCategoryStatusClick(category)
                          }}
                        />
                      )
                    )
                  } */}
                  
                  {
                    category?.id_membership_type !== 1 && (
                      loadingCategoryId === category.id_membership_type ? (
                        <CircularProgress size={24} style={styles.circularProgress} />
                      ) : (
                        hasAllPermissions(["cat_ups", 'cat_vw']) && <Switch
                          checked={category.is_active}
                          onChange={() => {
                            handleUpdateCategoryStatusClick(category)
                          }}
                        />
                      )
                    )
                  }
                  
                </Box>

                <Typography variant="h5" component="div" sx={styles.benefitsTitle}>
                  {category?.membership_name}
                </Typography>

                <Container sx={styles.benefitsContainer}>
                  <Typography color="text.secondary">
                    Descuento Liber
                  </Typography>
                  <Typography color="text.secondary">
                    {category?.liber_discount}%
                  </Typography>
                </Container>
                
                <Container sx={styles.benefitsContainer}>
                  <Typography color="text.secondary">
                    Descuento de terceros
                  </Typography>
                  <Typography color="text.secondary">
                    {category?.third_discount}%
                  </Typography>
                </Container>
                
                <Container sx={styles.benefitsContainer}>
                  <Typography color="text.secondary">
                    Descuento en productos
                  </Typography>
                  <Typography color="text.secondary">
                    {category?.product_buy_discount}%
                  </Typography>
                </Container>
                
                <Container sx={styles.benefitsContainer}>
                  <Typography color="text.secondary">
                    Descuento en almacenamiento
                  </Typography>
                  <Typography color="text.secondary">
                    {category?.storage_discount}%
                  </Typography>
                </Container>
                
                <Container sx={styles.benefitsContainer}>
                  <Typography color="text.secondary">
                    Notificaciones de proveedores
                  </Typography>
                  <Typography color="text.secondary">
                    {category?.supplier_notification ? 'Sí' : 'No'}
                  </Typography>
                </Container>

                <Container sx={styles.benefitsContainer}>
                  <Typography color="text.secondary">
                    Notificaciones de clientes
                  </Typography>
                  <Typography color="text.secondary">
                    {category?.client_notification ? 'Sí' : 'No'}
                  </Typography>
                </Container>

              </CardContent>
              {hasAllPermissions(["cat_upd", 'cat_vw']) && (<Divider />)}
              <CardActions>
                {hasAllPermissions(["cat_upd", 'cat_vw']) && (<IconButton
                  aria-label="edit"
                  onClick={() => {
                    setSelectedCategory(category)
                    handleDialogOpen("EditCategory")
                  }}
                  style={{
                    color: grey[500],
                    backgroundColor: alpha(blue[500], 0.1),
                  }}
                >
                  <Edit color={blue[500]} variant="Outline" />
                </IconButton>)}
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>

      <EditCategoryDialog
        open={openDialog === "EditCategory"}
        category={selectedCategory}
        onClose={handleDialogClose}
        onOpenDialog={handleDialogOpen}
        fetchCategories={fetchCategories}
      />
      <DeleteCategoryDialog
        open={openDialog === "DeleteCategory"}
        category={selectedCategory}
        onClose={handleDialogClose}
        onOpenDialog={handleDialogOpen}
        fetchCategories={fetchCategories}
      />
    </Container>
  );
};

export default GridContainer;
